import React, { useContext } from 'react';
import { Avatar, Box, Button, FormControlLabel, Switch, Typography } from '@mui/material';
import { ProxyLoginContext } from '../../../contexts/ProxyLoginContext';
import { orange20, orange50, orange40, gray100, gray30, white } from '../../../constants/colors';
import { PROXY_BANNER_HEIGHT } from '../../../constants/labels';
import { zIndexLayer } from '../../../constants/enum';
import HiStoryIcon from '../../assets/hi-story-icon.png';

const ProxyModeBanner = (): React.ReactElement | null => {
  const { isProxyLogin, targetCompanyName, endProxyLogin, isDetailMode, toggleDetailMode } =
    useContext(ProxyLoginContext);

  if (!isProxyLogin || !targetCompanyName) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: `${PROXY_BANNER_HEIGHT}px`,
        backgroundColor: orange20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 32px',
        zIndex: zIndexLayer.proxyBanner,
        gap: '32px',
        '@media screen and (max-width:960px)': {
          padding: '0 16px',
          gap: '16px',
          height: '48px',
        },
      }}
    >
      <Typography
        sx={{
          fontSize: '18px',
          color: gray100,
          fontWeight: '400',
          '@media screen and (max-width:960px)': {
            fontSize: '14px',
          },
        }}
      >
        {`代理モード中 : ${targetCompanyName}`}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        {/*
          事務局アイコン（#3203）: 代理モード中であることを示す表示のみで、押せない。
          #2315 で「代理先企業のアカウント管理・担当者一覧への導線が無い」ためメニューを付けたが、
          現在は GlobalHeader のアカウントメニューが代理中は代理先企業に解決されるため導線が重複していた。
          加えて「事務局＝運営」を示すロゴから代理先企業の画面へ遷移するのは分かりにくいため、
          メニューを廃止して表示専用に戻す（#2899 で保留された「アイコンごとにコンテキストを分ける」議論の整理）。
        */}
        <Avatar
          src={HiStoryIcon}
          alt="事務局"
          sx={{
            width: 30,
            height: 30,
            backgroundColor: 'transparent',
            border: `1px solid ${gray30}`,
          }}
        />
        <FormControlLabel
          control={<Switch checked={isDetailMode} onChange={toggleDetailMode} size="small" />}
          label="詳細"
          sx={{
            margin: 0,
            '& .MuiFormControlLabel-label': {
              fontSize: '14px',
              color: gray100,
              '@media screen and (max-width:960px)': {
                fontSize: '12px',
              },
            },
          }}
        />
        <Button
          sx={{
            backgroundColor: orange50,
            color: white,
            fontSize: '14px',
            fontWeight: '500',
            padding: '10px 16px',
            borderRadius: '4px',
            height: '44px',
            minWidth: '124px',
            '@media screen and (max-width:960px)': {
              height: '36px',
              minWidth: '100px',
              fontSize: '12px',
              padding: '6px 12px',
            },
            textTransform: 'none',
            '&:hover': {
              backgroundColor: orange40,
            },
          }}
          onClick={endProxyLogin}
        >
          代理モード終了
        </Button>
      </Box>
    </Box>
  );
};

export default ProxyModeBanner;
